import { ReturnStatus } from "@redotech/redo-return-core-common/return-status";

export function getAverageProcessingTimeLabel(
  averageProcessingDays: number,
  completedReturnCount: number,
): string | null {
  if (
    completedReturnCount <= 0 ||
    averageProcessingDays < 0 ||
    !Number.isFinite(averageProcessingDays)
  ) {
    return null;
  }

  if (averageProcessingDays < 1) {
    return "less than a day";
  }

  return averageProcessingDays === 1
    ? "1 day"
    : `${averageProcessingDays} days`;
}

export function isAutoProcessingEnabled({
  autoProcessGreenReturns,
  autoProcessGreenReturnTypes,
  returnProcessingAutomation,
}: AutoProcessingConfiguration): boolean {
  if (
    autoProcessGreenReturns ||
    (autoProcessGreenReturnTypes?.length ?? 0) > 0
  ) {
    return true;
  }

  if (!returnProcessingAutomation?.enabled) {
    return false;
  }

  return [
    returnProcessingAutomation.exchanges,
    returnProcessingAutomation.refunds,
    returnProcessingAutomation.storeCredit,
  ].some(
    (processingStatus) =>
      processingStatus !== undefined &&
      processingStatus !== ReturnStatus.COMPLETE,
  );
}

interface AutoProcessingConfiguration {
  autoProcessGreenReturns?: boolean;
  autoProcessGreenReturnTypes?: readonly unknown[];
  returnProcessingAutomation?: {
    enabled?: boolean;
    exchanges?: ReturnStatus;
    refunds?: ReturnStatus;
    storeCredit?: ReturnStatus;
  };
}
